import styled from 'styled-components';
import { infoColor, grayColor} from "~/components/layout/Variables";

export const TitlePage = styled.h1`
  color: white;
  font-size: 1.3rem;
  text-align: center;
  padding-top: 2rem;
  font-weight: 200;
  margin-bottom: -0.7rem;
  display: flex;
  justify-content: space-between;

  @media (min-width: 770px) {
    margin: 0 auto 0 auto;
    max-width: 762px;
  }

  img {
    @media (max-width: 770px) {
      margin-right: 1rem;
    }
  }

`;

export const CloseIconStyled = styled.img`
  width: 10%;
  height: 10%;
  position: relative;
  cursor: pointer;

  @media (min-width: 420px) {
    width: 8%;
    height: 8%;
  }

  @media (min-width: 500px) {
    width: 6%;
    height: 6%;
  }

  @media (min-width: 1000px) {
    width: 28px;
    height: 28px;
    margin-top: 19px;
  }
`;

export const Title = styled.h2`
  font-size: 1.1rem;
  font-weight: bold;
  color: ${() => grayColor};

  @media(min-width: 768px) {
    font-size: 1.2rem;
    margin: 1rem 0 0 0;
    display: flex;
    align-items: center;
  }
`;


export const SubTitle = styled.p`
  font-size: .95rem;
  color: ${() => grayColor};
  margin: 1rem 0.5rem 1.5rem 0rem;

  @media(min-width: 770px) {
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const Product = styled.span`
  font-size: 0.95rem;
  color: ${() => infoColor};
  display: flex;
  justify-content: left;
  align-items: center;

  @media (max-width: 700px) {
    text-align: center;
    justify-content: center;

    img {
      height: 1.6rem;
      padding-bottom: 0rem;
    }
  }
`;

export const Quantity = styled.span`
  font-size: 0.95rem;
  color: ${() => grayColor};
  display: flex;
  justify-content: end;

  @media (max-width: 700px) {
    text-align: left;
    justify-content: left;
    margin: 1rem 0 1rem 0;
  }
`;

export const QuantityIcon = styled.span`
  font-size: 0.95rem;
  color: ${() => grayColor};
  display: flex;
  justify-content: end;

  @media (max-width: 700px) {
    text-align: right;
    justify-content: right;
    margin: 1rem 0 1rem 0;
  }
`;

export const InputQuantity = styled.input`
  font-size: 0.95rem;
  text-align: center;
  background-color: #fff;
  border: 1px solid #b0b0b0;
  box-shadow: 0px 2px 4px #00000033;
  border-radius: 0.3rem;
  padding-top: 0.4rem;
  padding-bottom: 0.4rem;
  width: 100%;
`;

export const TextQuantity = styled(SubTitle)`
  text-align: right;
  margin: .5rem 0.5rem .5rem 0rem;

  @media (max-width: 700px) {
    text-align: center;
    margin: .5rem 0.5rem .5rem 0rem;
  }
`;

export const SelectProduct = styled.button`
  width: ${(props) => (props.width ? props.width : `100%`)};
  font-size: 1.2rem;
  color: #949494;
  border: 0.6px solid rgba(80, 80, 80, 0.3);
  background-color: #fff;
  box-shadow: 0px 2px 2px #00000029;
  border-radius: 0.4rem;
  padding: 0.2rem 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: ${(props) => props.margin};

  span {
    color: #000FFF;
  }
`;

export const ContainerButton = styled.div`
  width: 50%;
  margin: 1rem auto 1.5rem auto;

  @media (max-width: 700px) {
    width: 100%;
  }
`;

export const BackIcon = styled.span`
  display: flex;
  justify-content: flex-end;
  margin: 1rem 1rem 0 0;
  cursor: pointer;
`;

export const AlignProducts = styled.div`
  display: grid;
  grid-template-columns: 15% 65% 20%;
  width: 100%;

  .product {
    margin: .5rem .5rem .5rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .align-icon {
    margin: .5rem;
  }
`;

export const CardHeader = {
  backgroundColor: "rgb(230, 223, 223)",
  color: "rgb(112, 112, 112)",
  fontSize: ".9rem",
  fontWeight: "550",
  padding: ".2rem 1rem",
  borderTopLeftRadius: ".3rem",
  borderTopRightRadius: ".3rem",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  marginTop: "0.5rem",
  boxShadow: '0px 2px 4px #00000033'
};

export const AlignDropdownBranch = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  };

export const IconProductStyles = {
  display: "block",
  margin: "0 auto"
};

export const ButtonDivision = styled.div`
  width: 50%;
  margin: 1rem auto 1rem auto;

  @media(max-width: 600px) {
    width: 100%;
    margin: 1.5rem auto 0rem auto;
  }
`;

export const LoadingIcon = styled.i`
  font-size: 18px;
`;

export const ButtonOutline = styled.button`
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  width: 100%;
  height: 38px;
  background-color: ${(props) => (props.outline ? "transparent" : "#000FFF")};
  border-radius: 10px;
  color: ${(props) => (props.outline ? "#000FFF" : "#ffffff")};
  text-align: center;
  border: ${(props) => (props.outline ? "2px solid #000FFF" : "0")};
  overflow: hidden;
  box-shadow: ${(props) => (props.outline ? "0px 3px 8px #00000040" : "0px 3px 8px #00000059")};
  border-radius: ${(props) => (props.outline ? "8px" : "10px")};
  transition: 0.5s;
  &:hover {
    filter: brightness(85%);
  }
  img {
    float: left;
    padding-left: 0.7rem;
  }
  span {
    padding-right: 1.1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  @media(max-width: 600px) {
    height: auto;
  }
`;
